export const actionTypes = {
    UPDATE_FIRMWARE_SETTINGS: 'powertrainTools/gatewayManagement/UPDATE_FIRMWARE_SETTINGS',
    UPDATE_FIRMWARE: 'powertrainTools/gatewayManagement/UPDATE_FIRMWARE',
    CLEAR_STORE: 'powertrainTools/gatewayManagement/updateFirmware/CLEAR_STORE'
};

export const requestType = {
    TriggerDCUFirmwareUpdate: 'TriggerDCUFirmwareUpdate',
};
